import { AccountPermission } from './shared/consts/accountPermission';
import { AccountType } from './shared/consts/accountType';
import { hardcodedValues } from '../hardcodedValues';
import { acaConfig } from '../aca-config';
import { acaNames } from '../aca-names';
import { SearchableTypes } from './shared/common/search.model';

const onlyScientistTypes = [
  AccountType.scientist,
  AccountType.medLabTech,
  AccountType.labTech,
  AccountType.ssoAuthedUser,
];
const onlyCompanyTypes = [AccountType.industry, AccountType.university];
const allTypes = onlyScientistTypes.concat(onlyCompanyTypes);

export enum MondoRoutes {
  aboutSkuffen = 'aboutSkuffen',
  aboutNad = 'aboutNad',
  dashboard = 'dashboard',
  // home = 'home',
  // aboutUs = 'about',
  // jobBuilder = 'jobBuilder',
  scienceMatch = 'scienceMatch',
  scienceMatchJob = 'scienceMatchJob',
  scienceMatchSite = 'scienceMatchSite',
  scienceMatchCommunities = 'scienceMatchCommunities',
  scienceMatchEvents = 'scienceMatchEvents',
  scienceMatchIdeas = 'scienceMatchIdeas',
  map = 'map',
  // calendar = 'calendar',
  jobBuilder = 'jobBuilder',
  cvBuilder = 'cvBuilder',
  aboutUs = 'about',
  aboutPlatform = 'aboutPlatform',
  tutorials = 'tutorials',
  aboutSpecial = 'aboutSpecial',
  events = 'events',
  profileEditor = 'profile-editor',
  job = 'job',
  none = 'none',
  root = '/',
  link = 'link',
  communities = 'communities',
  ideas = 'ideas',
  homeProfile = 'homeProfile',
  siteBuilder = 'siteBuilder',
  cookies = 'cookies',
  newUser = 'new-user',
  emailActionManager = 'email-action-manager',
  login = 'login',
  signup = 'signup', // set to '' to hide signup
  landingPage = 'landing-page',
  chat = 'chat',
  kanban = 'kanban',
  playground = 'playground',
  // wpevents = 'wpevents',
  wptools = 'wptools',
  wp = 'wp',
  wp2 = 'wp2',
  multiwp = 'multiwp',
  home = 'home',
  adminPage = 'adminPage',
  gdpr = 'gdpr',
  ai = 'ai',
  aams = 'aams',
  fgu = 'fgu',
}

export const NewUserRoutes = {
  dashboard: acaConfig['enableStartpageForUnAuthedUsers']
    ? 'dashboard'
    : 'false', // option to show dashboard before signup
  // aams: 'aams',
  // fgu: 'fgu',
  scienceMatch: 'scienceMatch',
  map: acaConfig['disableMap'] ? 'false' : 'map',
  aboutUs: 'aboutUs',
  // events: 'events',
  // communities: 'communities',
  // ideas: 'ideas',
  // tutorials: 'tutorials',
  // aboutJobSearch: 'aboutJobSearch',
  // aboutJobBuilder: 'aboutJobBuilder',
};

export const RoutingModel = {
  landingPage: {
    excludeFromNavBar: true,
    title: '',
    path: 'landing-page',
    route: '/landing-page',
    icon: '',
    routeData: {
      animation: 'landing-page',
    },
  },
  emailActionManager: {
    excludeFromNavBar: true,
    title: '',
    path: 'email-action-manager',
    route: '/email-action-manager',
    icon: '',
    routeData: {
      animation: 'email-action-manager',
    },
  },
  cvBuilder: {
    excludeFromNavBar: true,
    title: hardcodedValues.CVBuilderTitle,
    path: hardcodedValues.CVBuilderRoute,
    route: '/' + hardcodedValues.CVBuilderRoute,
    icon: 'account_circle',
    routeData: {
      validAccountTypes: onlyScientistTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'cv-builder',
    },
  },
  jobBuilder: {
    title: hardcodedValues.jobBuilderTitle,
    path: hardcodedValues.jobBuilderRoute,
    route: '/' + hardcodedValues.jobBuilderRoute,
    icon: acaNames['jobBuilderIcon'] ? acaNames['jobBuilderIcon'] : 'work',
    routeData: {
      validAccountTypes: acaConfig.enableJobs ? allTypes : [],
      minimumPermission: AccountPermission.basic,
      animation: 'job-builder',
    },
  },
  adminPage: {
    excludeFromNavBar: true,
    title: hardcodedValues.adminRoute,
    path: hardcodedValues.adminRoute,
    route: '/' + hardcodedValues.adminRoute,
    icon: 'miscellaneous_services',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.admin,
      animation: 'admin-page',
    },
    lazy: './admin-page/admin-page.module#AdminPageModule',
  },
  gdpr: {
    excludeFromNavBar: true,
    title: 'gdpr',
    path: 'gdpr',
    route: '/gdpr',
    icon: 'miscellaneous_services',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'gdpr',
    },
  },
  ai: {
    excludeFromNavBar: hardcodedValues.chatbotBuilderApiHost ? false : true,
    title: 'AI',
    path: 'ai',
    route: '/ai',
    icon: 'miscellaneous_services',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.admin,
      animation: 'ai',
    },
  },
  aams: {
    excludeFromNavBar: true,
    title: 'AAMS',
    path: 'ai',
    route: '/ai/aams',
    icon: 'directions_boat',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'ai',
    },
  },
  fgu: {
    excludeFromNavBar: true,
    title: 'FGU',
    path: 'ai',
    route: '/ai/fgu',
    icon: 'directions_boat',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'ai',
    },
  },
  profileEditor: {
    excludeFromNavBar: true,
    title: hardcodedValues.profileEditorRoute,
    path: 'Settings',
    route: '/settings',
    icon: 'insert_drive_file',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'profile-editor',
    },
  },
  communities: {
    excludeFromNavBar: false,
    title: hardcodedValues.CommunitiesTitle,
    path: '_communities',
    route: '/_communities',
    icon: 'groups',
    routeData: {
      validAccountTypes: acaConfig.enableCommunities ? allTypes : [],
      minimumPermission: AccountPermission.basic,
      animation: '_communities',
    },
  },
  ideas: {
    excludeFromNavBar: acaNames.Idea ? false : true,
    title: acaNames.IdeasTitle,
    path: '_ideas',
    route: '/_ideas',
    icon: acaNames.IdeasIcon,
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: '_ideas',
    },
  },
  events: {
    excludeFromNavBar: false,
    title: hardcodedValues.EventTitle,
    path: '_events',
    route: '/_events',
    icon: 'events',
    routeData: {
      validAccountTypes: acaConfig.enableEvents ? allTypes : [],
      minimumPermission: AccountPermission.basic,
      animation: '_events',
    },
  },
  link: {
    excludeFromNavBar: true,
    title: hardcodedValues.profileRoute,
    path: 'link',
    route: '/link',
    icon: 'emoji_people',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'link',
    },
  },
  job: {
    excludeFromNavBar: true,
    title: hardcodedValues.jobRoute,
    path: 'job',
    route: '/job',
    icon: 'insert_drive_file',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'job',
    },
  },
  map: {
    excludeFromNavBar: acaConfig['disableMap']
      ? acaConfig['disableMap']
      : false,
    title: hardcodedValues.mapTitle,
    path: hardcodedValues.mapRoute,
    route: '/' + hardcodedValues.mapRoute,
    icon: 'map',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'map',
    },
  },
  newUser: {
    excludeFromNavBar: true,
    title: hardcodedValues.newUserRoute,
    path: 'new-user',
    route: '/new-user',
    icon: 'group',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'new-user',
    },
  },
  aboutUs: {
    excludeFromNavBar: true,
    title: hardcodedValues.aboutUsRoute,
    path: 'about/us',
    route: '/about/us',
    icon: 'group',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'aboutUs',
    },
  },
  aboutPlatform: {
    excludeFromNavBar: true,
    title: hardcodedValues.aboutUsRoute,
    path: 'about/platform',
    route: '/about/platform',
    icon: 'group',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'aboutPlatform',
    },
  },
  scienceMatchJob: {
    excludeFromNavBar: true,
    title: `${hardcodedValues.Discover} ${hardcodedValues.jobs}`,
    path: hardcodedValues.scienceMatchRoute,
    route: '/' + hardcodedValues.scienceMatchRoute + '/' + SearchableTypes.Job,
    icon: 'search',
    noReuse: true,
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'scienceMatchJob',
    },
  },
  scienceMatchSite: {
    excludeFromNavBar: true,
    title: `${hardcodedValues.Discover} ${hardcodedValues.site}`,
    path: hardcodedValues.scienceMatchRoute,
    route: '/' + hardcodedValues.scienceMatchRoute + '/' + SearchableTypes.Site,
    icon: 'search',
    noReuse: true,
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'scienceMatchSite',
    },
  },
  scienceMatchCommunities: {
    excludeFromNavBar: true,
    title: `${hardcodedValues.Discover} ${hardcodedValues.community}`,
    path: hardcodedValues.scienceMatchRoute,
    route:
      '/' + hardcodedValues.scienceMatchRoute + '/' + SearchableTypes.Community,
    icon: 'groups',
    noReuse: true,
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'scienceMatchCommunities',
    },
  },
  scienceMatchEvents: {
    excludeFromNavBar: true,
    title: `${hardcodedValues.Discover} ${hardcodedValues.event}`,
    path: hardcodedValues.scienceMatchRoute,
    route:
      '/' + hardcodedValues.scienceMatchRoute + '/' + SearchableTypes.Event,
    icon: 'events',
    noReuse: true,
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'scienceMatchEvents',
    },
  },
  scienceMatchIdeas: {
    excludeFromNavBar: true,
    title: `${hardcodedValues.Discover} ${hardcodedValues.idea}`,
    path: hardcodedValues.scienceMatchRoute,
    route: '/' + hardcodedValues.scienceMatchRoute + '/' + SearchableTypes.Idea,
    icon: acaNames.IdeasIcon,
    noReuse: true,
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'scienceMatchIdeas',
    },
  },
  aboutSkuffen: {
    excludeFromNavBar: true,
    title: 'Skuffesiden',
    path: 'about/skuffesiden',
    route: '/about/skuffesiden',
    icon: 'group',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.admin,
      animation: 'aboutSkuffen',
    },
  },
  aboutNad: {
    excludeFromNavBar: true,
    title: 'Nad',
    path: 'about/nad',
    route: '/about/nad',
    icon: 'group',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'aboutNad',
    },
  },
  tutorials: {
    title: hardcodedValues.about,
    path: 'tutorials',
    route: '/tutorials',
    icon: 'group',
    external: 'https://link.to/external',
    routeData: {
      validAccountTypes: [],
      minimumPermission: AccountPermission.basic,
      animation: 'tutorials',
    },
  },
  aboutSpecial: {
    title: acaConfig['aboutSpecial'] ? acaConfig['aboutSpecial'] : 'special',
    path: acaConfig['aboutSpecial'] ? acaConfig['aboutSpecial'] : 'special',
    route: `/about/${
      acaConfig['aboutSpecial'] ? acaConfig['aboutSpecial'] : 'special'
    }`,
    icon: acaConfig['aboutSpecialIcon']
      ? acaConfig['aboutSpecialIcon']
      : 'group',
    routeData: {
      validAccountTypes: acaConfig['aboutSpecial'] ? allTypes : [],
      minimumPermission: AccountPermission.basic,
      animation: 'aboutSpecial',
    },
  },
  aboutJobSearch: {
    excludeFromNavBar: true,
    title: hardcodedValues.aboutJobSearchRoute,
    path: 'about/jobSearch',
    route: 'about/jobSearch',
    icon: 'account_balance',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'aboutJobSearch',
    },
  },
  aboutJobBuilder: {
    excludeFromNavBar: true,
    title: hardcodedValues.aboutJobBuilderRoute,
    path: 'about/jobBuilder',
    route: 'about/jobBuilder',
    icon: 'work',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'aboutJobBuilder',
    },
  },
  login: {
    excludeFromNavBar: true,
    title: hardcodedValues.login,
    path: 'login',
    route: 'login',
    icon: 'login',
    routeData: {
      // validAccountTypes: allTypes,
      // minimumPermission: AccountPermission.basic,
      animation: 'login',
    },
  },
  signup: {
    excludeFromNavBar: true,
    title: hardcodedValues.signUp,
    path: 'signup',
    route: 'signup',
    icon: 'how_to_reg',
    routeData: {
      // validAccountTypes: allTypes,
      // minimumPermission: AccountPermission.basic,
      animation: 'signup',
    },
  },
  chat: {
    excludeFromNavBar: true,
    title: hardcodedValues.chatRoute,
    path: 'chat',
    route: 'chat',
    icon: 'chat',
    routeData: {
      validAccountTypes: hardcodedValues.enableChat ? allTypes : [],
      minimumPermission: AccountPermission.basic,
      animation: 'chat',
    },
  },
  playground: {
    excludeFromNavBar: true,
    title: 'Playground',
    path: 'playground',
    route: 'playground',
    icon: 'accessible_forward',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.admin,
      animation: 'playground',
    },
  },
  // wpevents: {
  //   excludeFromNavBar: acaConfig['urlForWordpressACFEvents'] ? false : true,
  //   title: acaConfig['TitleForWordpressevents'],
  //   path: 'wp',
  //   route: '/wp/events',
  //   icon: 'events',
  //   routeData: {
  //     validAccountTypes: acaConfig['urlForWordpressACFEvents'] ? allTypes : [],
  //     minimumPermission: AccountPermission.basic,
  //     animation: 'events',
  //   },
  // },
  wp: {
    excludeFromNavBar: acaConfig['urlForWordpressnews'] ? false : true,
    title: acaConfig['TitleForWordpressnews'],
    path: 'wp',
    route: '/wp/posts/news',
    icon: 'newspaper',
    routeData: {
      validAccountTypes: acaConfig['urlForWordpressnews'] ? allTypes : [],
      minimumPermission: AccountPermission.basic,
      animation: 'news',
    },
  },
  wp2: {
    excludeFromNavBar: acaConfig['urlForWordpressnews2'] ? false : true,
    title: acaConfig['TitleForWordpressnews2'],
    path: 'wp',
    route: '/wp/posts/news2',
    icon: 'newspaper',
    routeData: {
      validAccountTypes: acaConfig['urlForWordpressnews2'] ? allTypes : [],
      minimumPermission: AccountPermission.basic,
      animation: 'news2',
    },
  },
  multiwp: {
    excludeFromNavBar: acaConfig['EnableMultiwordpressFeeds'] ? false : true,
    title: acaConfig['TitleForMultiwordpressFeeds'],
    path: 'wp',
    route: '/wp/posts/multi',
    icon: 'newspaper',
    routeData: {
      validAccountTypes: acaConfig['EnableMultiwordpressFeeds'] ? allTypes : [],
      minimumPermission: AccountPermission.basic,
      animation: 'multiwp',
    },
  },
  wptools: {
    excludeFromNavBar: acaConfig['urlForWordpresstools'] ? false : true,
    title: acaConfig['TitleForWordpresstools'],
    path: 'wp',
    route: '/wp/posts/tools',
    icon: 'build',
    routeData: {
      validAccountTypes: acaConfig['urlForWordpresstools'] ? allTypes : [],
      minimumPermission: AccountPermission.basic,
      animation: 'wptools',
    },
  },
  cookies: {
    excludeFromNavBar: true,
    title: hardcodedValues.cookiesRoute,
    path: 'cookies',
    route: '/cookies',
    icon: 'cookies',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'cookies',
    },
  },
  dashboard: {
    excludeFromNavBar: false,
    title: hardcodedValues.dashboardTitle,
    path: hardcodedValues.dashboardRoute,
    route: '/' + hardcodedValues.dashboardRoute,
    icon: 'home',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'dashboard',
    },
  },
  home: {
    excludeFromNavBar: true,
    title: hardcodedValues.siteBuilderRoute,
    path: 'home',
    route: '/home',
    icon: 'business',
    routeData: {
      validAccountTypes: onlyCompanyTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'home',
    },
  },
  siteBuilder: {
    excludeFromNavBar: true,
    root: 'Site',
    hint: hardcodedValues.Site,
    title: hardcodedValues.siteBuilderRoute,
    path: 'site-builder',
    route: '/home/site-builder',
    icon: 'edit',
    routeData: {
      validAccountTypes: onlyCompanyTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'siteBuilder',
    },
    page: 'home',
  },
  homeProfile: {
    excludeFromNavBar: true,
    hint: hardcodedValues.CV,
    root: 'profile',
    title: hardcodedValues.homeProfileRoute,
    path: 'profile',
    route: '/home/profile',
    icon: 'edit',
    routeData: {
      validAccountTypes: [],
      minimumPermission: AccountPermission.basic,
      animation: 'homeProfile',
    },
    page: 'home',
  },
  scienceMatch: {
    excludeFromNavBar: false,
    title: hardcodedValues.scienceMatch,
    path: hardcodedValues.scienceMatchRoute,
    route: '/' + hardcodedValues.scienceMatchRoute,
    icon: 'search',
    // iconUrl: '/assets/logos/AM.svg',
    noReuse: true, // TBD - fix perhaps route observable - to detect changes in url and search accordingly could work...
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'scienceMatch',
    },
  },
  calendar: {
    title: hardcodedValues.calendar,
    path: 'calendar',
    route: 'calendar',
    icon: 'calendar_today',
    routeData: {
      validAccountTypes: allTypes,
      minimumPermission: AccountPermission.basic,
      animation: 'calendar',
    },
  },
};

export interface INavigationItem {
  title: string;
  path: string;
  icon: string;
  route: string;
  routeData: IRouteData;
  excludeFromNavBar: boolean;
  external: boolean;
  root: string;
  page: string;
  hint: string;
}

export interface IRouteData {
  validAccountTypes: AccountType[];
  minimumPermission: AccountPermission;
  animation: string;
}
